import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ubs-blog-components',
  template: `
    <router-outlet></router-outlet>
  `,
})
export class UbsBlogComponentsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
